/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Created_UtcInputs */

const en_tables_rule_sets_created_utc = /** @type {(inputs: Tables_Rule_Sets_Created_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Created UTC`)
};

const de_tables_rule_sets_created_utc = /** @type {(inputs: Tables_Rule_Sets_Created_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt von (UTC)`)
};

/**
* | output |
* | --- |
* | "Sets Created UTC" |
*
* @param {Tables_Rule_Sets_Created_UtcInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_created_utc = /** @type {((inputs?: Tables_Rule_Sets_Created_UtcInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Created_UtcInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_created_utc(inputs)
	return de_tables_rule_sets_created_utc(inputs)
});